import jwtDecode, { JwtPayload } from "jwt-decode";
import { userService } from '../services/userService';

export function authHeader2() {
  const token = localStorage.getItem('accessToken');
  const oktaToken = JSON.parse(localStorage.getItem('okta-token-storage')||'{}').accessToken.accessToken;
  return authCheck(token).then(token => {
    //return authCheckOkta(oktaToken).then(oktaToken => {
      return {
        token: 'Bearer '+token,
        oktaToken: 'Bearer '+oktaToken 
      }
    //})
  })
}

export function authHeader() {
  // return authorization header with jwt token
  let token = localStorage.getItem('accessToken');
  return authCheck(token).then(token => {
    return 'Bearer ' + token;   
  }).catch(error => {
    return Promise.reject(error);
  });
}

/*function authCheckOkta(token) {
  if (token) {
    const decode: JwtPayload = jwtDecode(token);
    if (decode && decode.iat && decode.exp) {
      const now = Date.now();  
      let iatDate = new Date(1970, 0, 1);
      iatDate.setSeconds(decode.iat);
      const iat = iatDate.getTime();
      let expDate = new Date(1970, 0, 1);
      expDate.setSeconds(decode.exp);
      const exp = expDate.getTime();
      const diffToken = exp - iat;
      const diffNow = now - iat;
      if(diffNow > (diffToken / 2)){
      //if (diffNowIat>diffExpNow) {
        const refresh = JSON.parse(localStorage.getItem('okta-token-storage')||'{}').refreshToken.refreshToken;
        return userService.refreshOktaToken(refresh).then(data => {
          return Promise.resolve(data.access_token);
        }).catch(error => {
          return Promise.reject(error);
        });

      }
      return Promise.resolve(token);
    }
  }
  return Promise.reject({ response: { data: { error: { message: "jwtExpired" }}}});
}*/

function authCheck(token){
  if(token){
    const decode: JwtPayload = jwtDecode(token);
    if(decode && decode.iat && decode.exp){
      const now = Date.now();  
      // Set expiration date [epoch + seconds]
      let iatDate = new Date(1970, 0, 1);
      iatDate.setSeconds(decode.iat);    
      const iat = iatDate.getTime();
      let expDate = new Date(1970, 0, 1);
      expDate.setSeconds(decode.exp);    
      const exp = expDate.getTime();
      const diffToken = exp - iat;
      const diffNow = now - iat;
      if(diffNow > (diffToken / 2)){
      // if(diffNow < (diffToken)){ // USED ONLY FOR TESTING
        const refresh = localStorage.getItem('refreshToken');
        return userService.refreshToken(refresh).then(data => {
          return Promise.resolve(data.accessToken);
        }).catch(error => {
          return Promise.reject(error);
        });
      }
      return Promise.resolve(token);
    }
  }
  // history.push('/');
  return Promise.reject({ response: { data: { error: { message: "jwtExpired" }}}});
}
